import { formatCurrency as o } from "../i18n/formatCurrency.js";
import { formatDate as r } from "../i18n/formatDate.js";
const e = () => ({
  firstDayOfWeek: 1,
  formatCurrency: o,
  formatDate: r
});
export {
  e as useLocalisation
};
//# sourceMappingURL=useLocalisation.js.map
